import React from "react";
import { Chip } from "@mui/joy";

export type CardTagColor = "neutral" | "primary" | "danger" | "warning" | "success";

interface Props {
    label: React.ReactNode;
    color?: CardTagColor;
}

/** Soft status/category chip used in card headers. */
const CardTag = ({ label, color = "neutral" }: Props) => (
    <Chip size="md" variant="soft" color={color}>
        {label}
    </Chip>
);

export default CardTag;
